<template>
  <div class="custom-order-detail">
    <Breadcrumb></Breadcrumb>
    <div class="detail-content border">
      <div class="order-info">
        <el-row type="flex">
          <el-col :span="4" style="padding-bottom: 15px">
            <div><img :src="imgUrl1" /></div>
            <div style="font-weight: 600">
              {{ getStateName(tableData.orderStatus) }}
            </div>
          </el-col>
          <el-col :span="2">
            <div>订单编号：</div>
            <div>下单时间：</div>
          </el-col>
          <el-col :span="4">
            <div style="text-align: left">{{ tableData.appNo }}</div>
            <div style="text-align: left">
              {{ getFormateDate(tableData.orderTime) }}
            </div>
          </el-col>
          <el-col :span="2">
            <template v-if="1 == 2">
              <el-button type="primary">立即付款</el-button>
              <el-button>取消订单</el-button>
            </template>
            <template v-else> </template>
          </el-col>
        </el-row>
      </div>
      <div class="det-c">
        <el-steps :active="activeNum" align-center>
          <el-step
            title="提交订单"
            :description="getFormateDate(tableData.orderTime)"
          ></el-step>
          <el-step
            title="付款成功"
            :description="getFormateDate(tableData.payTime)"
          ></el-step>
          <el-step
            title="排单中"
            :description="getFormateDate(tableData.payTime)"
          ></el-step>
          <el-step
            title="生产中"
            :description="getFormateDate(tableData.payTime)"
          ></el-step>
          <el-step
            title="已发货"
            :description="getFormateDate(tableData.sendTime)"
          ></el-step>
        </el-steps>
        <div class="det-til">收货信息</div>
        <div class="det-rec border">
          <el-row>
            <el-col :span="2"
              ><span style="padding-left: 15px">收货人：</span></el-col
            >
            <el-col :span="20"
              ><span>{{ tableData.receName }}</span></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="2"><span>联系方式：</span></el-col>
            <el-col :span="20"
              ><span>{{ tableData.mobile }}</span></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="2"><span>收货地址：</span></el-col>
            <el-col :span="20"
              ><span>{{ tableData.fullAddr }}</span>
            </el-col>
          </el-row>
        </div>
        <div class="det-til">商品信息</div>
        <div class="det-tab">
          <el-table
            :data="tableData.details"
            ref="shopCartTable"
            class="border"
          >
            <el-table-column label="商品信息" align="center">
              <template slot-scope="scope">
                <div class="tab-sku-col">
                  <div class="sku-img" style="margin-right: 10px;">
                    <img
                      :src="scope.row.picUrl"
                      style="width: 100px;height: 100px"
                    />
                  </div>
                  <div class="sku-attr">
                    <el-row class="sku-title">{{ scope.row.prodTitle }}</el-row>
                    <el-row>
                      <template
                        v-for="(item, index) in scope.row.properName.split(':')"
                      >
                        <span style="margin-right: 5px;"
                          >{{ item }}:{{
                            scope.row.properVal.split(":")[index]
                          }}</span
                        >
                      </template>
                    </el-row>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="单价"
              align="center"
              class="pro-col"
              width="100"
            >
              <template slot-scope="scope">
                <span>¥</span><span>{{ scope.row.price.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="count"
              label="数量"
              align="center"
              class="pro-col"
              width="200"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.num }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="小计"
              align="center"
              class="pro-col"
              prop="subtotal"
              width="100"
            >
              <template slot-scope="scope">
                <span>¥</span><span>{{ scope.row.total.toFixed(2) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="money-info">
          <el-row type="flex">
            <el-col><span>商品件数：</span></el-col>
            <el-col
              ><span>{{ flexData.num }}件</span></el-col
            >
          </el-row>
          <el-row type="flex">
            <el-col><span>商品总价：</span></el-col>
            <el-col
              ><span>¥{{ flexData.proPri.toFixed(2) }}</span></el-col
            >
          </el-row>
          <el-row type="flex">
            <el-col><span>运费：</span></el-col>
            <el-col
              ><span>¥{{ flexData.fare.toFixed(2) }}</span></el-col
            >
          </el-row>
          <el-row type="flex">
            <el-col><span>应付总额：</span></el-col>
            <el-col
              ><span style="font-weight:600"
                >¥{{ flexData.actPay.toFixed(2) }}</span
              ></el-col
            >
          </el-row>
          <el-row v-if="tableData.orderStatus == '01' && showPayButton">
            <el-button
              style="margin: 20px"
              type="primary"
              @click="payAtTime(tableData.details)"
              >立即付款</el-button
            >
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/common/Breadcrumb"
import { details } from "@/api/mine/order"
import { mapGetters } from "vuex"
import { formatState, formateDate } from "@/utils/custom"
import { submitPcOrder } from "@/api/business/moneyManger.js"

export default {
  name: "orderDetaile",
  components: { Breadcrumb },
  data() {
    return {
      imgUrl1: require("../../../assets/images/ok.png"),
      tableData: [],
      activeNum: -1,
      flexData: { num: 0, proPri: 0.0, fare: 0.0, actPay: 0.0 },
    }
  },
  computed: {
    // orderInfo() {
    // console.log(JSON.parse(this.$route.query.row));
    // return JSON.parse(this.$route.query.row);
    // },

    ...mapGetters(["nginx"]),
    showPayButton() {
      let permission = JSON.stringify(this.$store.state.permission)
      return permission.indexOf("GetPay") !== -1
    },
  },

  methods: {
    loadData() {
      if (this.$route.query.orderStatus == "06") {
        this.imgUrl1 = require("../../../assets/images/cancel.png")
      } else if (this.$route.query.orderStatus == "01") {
        this.imgUrl1 = require("../../../assets/images/wait1.png")
      }
      let orderDetails = sessionStorage.getItem("orderDetails")
      let order = null
      if (orderDetails == null) {
        order = this.$route.query
        sessionStorage.setItem(
          "orderDetails",
          JSON.stringify({ tableData: order })
        )
      } else {
        let listData = JSON.parse(orderDetails)
        order = listData.tableData
      }
      this.tableData = order
      let details = order.details

      this.flexData.fare = order.fare
      this.flexData.actPay = order.actPay
      details.forEach((re) => {
        this.flexData.num += re.num
        this.flexData.proPri += re.total
      })
      let status = parseInt(order.orderStatus)
      if (status < 6) {
        this.activeNum = status
      }
    },
    //立即付款
    payAtTime(row) {
      let map = {}
      let spl = ""
      for (var i = 0; i < row.length; i++) {
        let split = row[i].properName.split(":")
        let split1 = row[i].properVal.split(":")
        for (var j = 0; j < split.length; j++) {
          let aa = split[j] + ":" + split1[j] + " "
          spl += aa + " \n "
        }
      }
      map["body"] = spl
      map["subject"] = row[0].prodTitle
      map["total_amount"] = "0.01"
      console.log(map)
      submitPcOrder(map)
        .then((res) => {
          if (res) {
            document.querySelector("body").innerHTML = res
            const div = document.createElement("div") // 创建div
            div.innerHTML = res // 将返回的form 放入div
            document.body.appendChild(div)
            document.forms[0].submit()
          }
        })
        .catch((err) => {})
    },
    // 状态常量转为中文
    getStateName(state) {
      return formatState(state)
    },
    // 格式化时间
    getFormateDate(time) {
      return formateDate(time)
    },
  },

  created() {
    var that = this
    that.loadData()
  },

  beforeDestroy() {
    // 离开页面后销毁
    sessionStorage.removeItem("orderDetails")
  },
}
</script>

<style scoped></style>
